import * as Yup from 'yup'

export const updateDataModel = Yup.object().shape({
    entities: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required(),
            alliance: Yup.string(),
            latitude: Yup.number()
                .required('Entity Longitude value is required')
                .min(-90, 'Latitude must be higher or equal than -90')
                .max(90, 'Latitude must be lower or equal than 90'),
            longitude: Yup.number()
                .required('Entity Longitude value is required')
                .min(-180, 'Longitude must be higher or equal than -180')
                .max(180, 'Longitude must be lower or equal than 180'),
            altitude: Yup.number(),
            velocity: Yup.number(),
            yaw: Yup.number(),
            pitch: Yup.number(),
            roll: Yup.number(),
            payloads: Yup.string(),
            created_at: Yup.number(),
            updated_at: Yup.number(),
        }),
    ),
})
